'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00247 from "./presto.-Presto$$anon$7.js";
import * as $j_presto$002etypes$0024$002dCompact$002dGroup$0024 from "./presto.types$-Compact-Group$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$6() {
  this.bcV = null;
  this.bcN = null;
  this.bcO = false;
  this.bcW = null;
  this.bcX = false;
  this.bd0 = null;
  this.bcT = null;
  this.bcU = false;
  this.bcP = null;
  this.bcQ = false;
  this.bcR = null;
  this.bcS = false;
  this.bcY = false;
  this.bcZ = false;
  this.bcV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bd0 = "CompactGroup";
}
export { $c_Lpresto_Presto$$anon$6 as $c_Lpresto_Presto$$anon$6 };
$p = $c_Lpresto_Presto$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$6;
/** @constructor */
function $h_Lpresto_Presto$$anon$6() {
}
export { $h_Lpresto_Presto$$anon$6 as $h_Lpresto_Presto$$anon$6 };
$h_Lpresto_Presto$$anon$6.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bcV;
});
$p.M = (function() {
  if ((!this.bcO)) {
    this.bcN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bcO = true;
  }
  return this.bcN;
});
$p.O = (function() {
  if ((!this.bcX)) {
    this.bcW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bcX = true;
  }
  return this.bcW;
});
$p.D = (function() {
  return this.bd0;
});
$p.t = (function() {
  if ((!this.bcU)) {
    this.bcT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bcU = true;
  }
  return this.bcT;
});
$p.N = (function() {
  if ((!this.bcQ)) {
    this.bcP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iQ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kF())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bcQ = true;
  }
  return this.bcP;
});
$p.Q = (function() {
  if ((!this.bcS)) {
    this.bcR = new $j_presto$002e$002dPresto$0024$0024anon$00247.$c_Lpresto_Presto$$anon$7();
    this.bcS = true;
  }
  return this.bcR;
});
$p.v = (function() {
  if ((!this.bcZ)) {
    this.bcY = false;
    this.bcZ = true;
  }
  return this.bcY;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee50) => ((p) => \u03b4scrutinee50.adF(p)))($j_presto$002etypes$0024$002dCompact$002dGroup$0024.$m_Lpresto_types$CompactGroup$())));
});
var $d_Lpresto_Presto$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$6, "presto.Presto$$anon$6", ({
  Np: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$6 as $d_Lpresto_Presto$$anon$6 };
//# sourceMappingURL=presto.-Presto$$anon$6.js.map
